import DigiLogoLarge from './logos/large.png';

export const LogoFull = () => {
  return <img src={DigiLogoLarge} width="190" alt="Digitalist Open Cloud" />;
};

export default LogoFull;
